/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, withProps } from 'recompose';
import { Container } from 'components/atoms/Page';
import { FAQItem, SectionHeader } from 'components/molecules';
import StorageImage from 'assets/images/psp/Faq/StorageImage.svg';

import './FAQSection.scss';

export const enhance = compose(
	withProps(({ content }) => {
		const faqs = content && Array.isArray(content.faqs) ? content.faqs : [];
		const faqSchema = {
			'@context': 'http://schema.org',
			'@type': 'FAQPage',
			mainEntity: faqs.map((faq) => ({
				'@type': 'Question',
				name: faq.question,
				acceptedAnswer: {
					'@type': 'Answer',
					text: faq.answer,
				},
			})),
		};

		const stringifiedFaqSchema = JSON.stringify(faqSchema);
		return { faqSchema: stringifiedFaqSchema };
	}),
);

export function FAQSection({ className, content, faqSchema }) {
	const {
		header = '',
		description = '',
		image = StorageImage,
		faqs = [],
	} = content;
	return (
		<div className={classnames(className, 'faq')}>
			<Container>
				<SectionHeader
					image={image}
					header={header}
					description={description}
				/>
				<FAQItem content={faqs} />
				{faqSchema && (
					<script
						key="schema"
						type="application/ld+json"
						dangerouslySetInnerHTML={{
							__html: faqSchema,
						}}
					/>
				)}
			</Container>
		</div>
	);
}

FAQSection.propTypes = {
	className: PropTypes.string,
	content: PropTypes.shape({
		header: PropTypes.string,
		description: PropTypes.string,
		image: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.shape({
				src: PropTypes.string,
			}),
		]),
		faqs: PropTypes.arrayOf(
			PropTypes.shape({
				question: PropTypes.string,
				answer: PropTypes.string,
			}),
		),
	}),
	faqSchema: PropTypes.string,
};

FAQSection.defaultProps = {
	content: {
		header: '',
		description: '',
		image: '',
		faqs: [],
	},
};

export default enhance(FAQSection);
